<div class="cf-templates-dialog">
  <div mat-dialog-title oneDialogTitle>
    <span i18n="@@input-dialog-example.title">Feedback option templates</span>
    <p i18n="@@input-dialog-example.patient-name">Select the feedback options you want to add by checking the checkbox(es) and click on "Add to feedback form".</p>
  </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <dl-cf-feedback-template [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newFeedbackOption" [displayedColumns]="templateColumn" [tableData]="templateData" *ngIf="templateData.length > 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)" (isFoRowSelected)="getSelectedRowInTemplate($event)"></dl-cf-feedback-template>
  </div>
  <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
    <button
      one-secondary-button
      mat-stroked-button     
       [mat-dialog-close]="true"
    > Cancel
    </button>
    <button color="primary" [disabled]="isNtBtnDisabled" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="newTemplateClicked()">
      New template
    </button>
    <button color="primary" [disabled]="isAffBtnDisabled" [mat-dialog-close]="data" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="addFeedbackToForm()" >
      Add to feedback form
    </button>
  </div>
</div>
